<template>
  <v-dialog v-model="dialog"
            max-width="700px"
            @click:outside="cancel"
            @keydown.esc="cancel">
    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card>
        <v-card-title>
          Create Link For: {{ presentation.name }}
        </v-card-title>
        <v-card-text class="pb-0">
          <v-autocomplete v-model="form.contact"
                          ref="recipientAutocomplete"
                          :disabled="form.busy"
                          outlined
                          clearable
                          label="Who is this link for?"
                          placeholder="Search your contacts."
                          :search-input.sync="search"
                          :items="normalizedContacts"
                          item-value="id"
                          item-text="name_email_company_record_type"
                          return-object
                          no-data-text="Search your contacts."
                          :error-messages="form.errors.get('user_contact_id')"
                          @change="checkContact">
            <template v-slot:append-item
                      v-if="isAllergan && normalizedContacts.length > 0">
              <v-list-item>
                <div class="mr-4">
                  <strong>"{{ search }}" not found in {{ crmLabel }}.</strong>
                </div>
                <div>
                  If you just added or changed an email address in {{ crmLabel }}, <a href="#" @click.prevent="syncFromMoxie">import from {{ crmLabel }}</a>.
                </div>
              </v-list-item>
            </template>
            <template v-else-if="search && search.trim() && normalizedContacts.length === 0"
                      v-slot:no-data>
              <v-list-item v-if="isAllergan">
                <div class="mr-4">
                  <strong>"{{ search }}" not found in {{ crmLabel }}.</strong>
                </div>
                <div>
                  If you just added or changed an email address in {{ crmLabel }}, <a href="#" @click.prevent="syncFromMoxie">import from {{ crmLabel }}</a>.
                </div>
              </v-list-item>
              <v-list-item v-else>
                <strong>"{{ search }}" not found.</strong>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-card-text>
        <ErrorAlert :error="error">
        </ErrorAlert>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary"
                 :disabled="!isFormValid">
            Create Link
          </v-btn>
          <v-btn @click.prevent="cancel">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {Form} from 'vform';
import {mapGetters} from 'vuex';
import validationService from '../../../services/validationService';
import userContactService from '../../../services/userContactService';
import {isArray, isObject} from 'lodash';
import clipboardService from '../../../../../ml/services/clipboardService';
import moment from 'moment-timezone';
import axios from '../../../services/axiosService';
import ErrorAlert from '../../../components/ErrorAlert.vue';

export default {
  components: {ErrorAlert},
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    presentation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      contacts: [],
      loading: false,
      search: '',
      error: null,
      link: null,
      form: new Form({
        contact: null,
        presentation_id: this.presentation.id,
      }),
    }
  },
  computed: {
    ...mapGetters([
      'canCreateContact',
      'canEmailSelf', // MLD-5505
      'crmLabel',
      'isAdmin',
      'isMember',
      'team',
      'user',
    ]),
    normalizedContacts() {
      return this.contacts;
    },
    isFormValid() {
      return isObject(this.form.contact);
    },
    isAllergan() {
      return this.team
        && this.team.id === 194;
    },
  },
  watch: {
    search(val) {
      this.searchContacts(val);
    },
  },
  created() {

  },
  methods: {
    searchContacts(query) {
      if (!query) {
        this.loading = false;
        this.contacts = [];
        return;
      }
      this.loading = true;
      const isEmail = validationService.isEmailValid(query);
      const form = {
        email: isEmail ? query : null,
        query: isEmail ? null : query,
        order_by: 'updated_at',
        order_dir: 'desc',
        limit: 10,
        status: 'Active', // MLD-3304
      }
      return userContactService.search(form, this.user)
        .then(data => {
          if (isArray(data.hits)) {
            this.contacts = data.hits;
          } else {
            this.contacts = data;
          }
        })
        .finally(() => {
          this.loading = false;
        })
    },
    async checkContact() {
    },
    async submit() {
      if (this.form.busy) {
        return;
      }
      if (!this.form.contact) {
        return;
      }
      this.error = null;
      const form = {
        presentation_id: this.form.presentation_id,
        source: 'website',
        type: 'Link',
        user_contact_id: this.form.contact.id,
      }
      try {
        this.form.startProcessing();
        const response = await axios.post(`/api/shared-links`, form)
        this.link = response.data;
        await clipboardService.copy(this.link.share_url, false)
        this.$toast.success('Link copied! Ready to share.');
        this.form.reset();
        this.closeDialog();
        this.form.finishProcessing()
      } catch (err) {
        this.form.handleErrors(err);
        this.error = err;
      }
    },
    closeDialog() {
      this.$emit('close');
    },
    cancel() {
      this.closeDialog();
    },
    syncFromMoxie() { // MLD-3237
      this.showSyncDialog = true;
      const startAt = moment().startOf('day');
      userContactService.syncFromCRM(this.user.id, startAt.format())
        .then(data => {
          if (data.enriching) {

          } else {
            this.$toast.error('Your contacts could not be synced from Moxie.');
            this.showSyncDialog = false;
          }
        })
    },
  }
}
</script>
